import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
	StatusOverlayComponent
} from '@go-modules/components/video-scene/status-overlay/status-overlay.component';
import { NetworkIndicatorModule } from '@go-modules/components/network-indicator/network-indicator.module';
import { VolumeIndicatorComponent } from '@go-modules/components/video-scene/volume-indicator/volume-indicator.component';
import { RealTimeCaptionsModule } from '../real-time-captions/real-time-captions.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		NetworkIndicatorModule,
		RealTimeCaptionsModule
	],
	exports: [
		StatusOverlayComponent,
		VolumeIndicatorComponent
	],
	declarations: [
		StatusOverlayComponent,
		VolumeIndicatorComponent
	]
})
export class VideoSceneModule {}
